import { createContext } from "react";

const StudentClassContext = createContext();

export default StudentClassContext;
